import React from "react";
import Articles from "../screens/articles";
import News from "../screens/news";
import UserEdit from "../screens/users/userUnfo/UserEdit";
import CalcPage from "../screens/users/calcPage/CalcPage";
import Users from "../screens/users";
import PropertyReports from "../screens/property-reports";
import UserEnquiry from "../screens/page-management/user-enquiry";
import SubAdmin from "../screens/sub-admin";
import SiteSettings from "../screens/site-settings";
import Faq from "../screens/page-management/faq";
import Team from "../screens/page-management/team";
import Contact from "../screens/page-management/contact";
import PrivacyPolicy from "../screens/page-management/privacyPolicy";
import Refinance from "../screens/page-management/refinance";
import NextHome from "../screens/page-management/next-home";
import Investment from "../screens/page-management/investment";
import FirstHome from "../screens/page-management/first-home";
import Construction from "../screens/page-management/construction";

import articleIcon from "../assets/icons/articles.svg"
import newsIcon from "../assets/icons/book.svg";
import CalcIcon from "../assets/icons/calculator.svg";
import usersIcon from "../assets/icons/users.svg";
import bookIcon from "../assets/icons/book.svg";
import faq from "../assets/icons/faq.svg";
import team from "../assets/icons/team.svg";
import contactDetails from "../assets/icons/contactDetails.svg";
import construction from "../assets/icons/construction.svg";

export const RouteElement: { [key: string]: any } = {
    "articles": <Articles />,
    "news": <News />,
    "userEdit": <UserEdit />,
    "calcPage": <CalcPage />,
    "users": <Users />,
    "propertyReports": <PropertyReports />,
    "userEnquiry": <UserEnquiry />,
    "subAdmin": <SubAdmin />,
    "siteSettings": <SiteSettings />,
    "faq": <Faq />,
    "team": <Team />,
    "contactDetails": <Contact />,
    "privacyPolicy": <PrivacyPolicy />,
    "refinance": <Refinance />,
    "nextHome": <NextHome />,
    "invest": <Investment />,
    "firstHome": <FirstHome />,
    "construction": <Construction />,
}

export const ImageElement: { [key: string]: any } = {
    "articlesIcon": <img src={articleIcon} alt="icon" className="icon" />,
    "newsIcon": <img src={newsIcon} alt="icon" className="icon" />,
    "calcIcon": <img src={CalcIcon} alt="icon" className="icon" />,
    "bookIcon": <img src={bookIcon} alt="icon" className="icon" />,
    "usersIcon": <img src={usersIcon} alt="icon" className="icon" />,
    "faq": <img src={faq} alt="icon" className="icon" />,
    "team": <img src={team} alt="icon" className="icon" />,
    "contactDetails": <img src={contactDetails} alt="icon" className="icon" />,
    "construction": <img src={construction} alt="icon" className="icon" />,
}
